<template>
  <div>
    <template v-if="readonly">
      <v-list-item dense class="px-0 my-n2">
        <span class="font-weight-medium me-2">{{ $t('street') }}:</span>
        <span class="text--secondary">{{ emptyValueFormatter(value.street) }}</span>
      </v-list-item>

      <v-list-item dense class="px-0 my-n2">
        <span class="font-weight-medium me-2">{{ $t('houseNumber') }}:</span>
        <span class="text--secondary">{{ emptyValueFormatter(value.houseNumber) }}</span>
      </v-list-item>

      <v-list-item dense class="px-0 my-n2">
        <span class="font-weight-medium me-2">{{ $t('flatNumber') }}:</span>
        <span class="text--secondary">{{ emptyValueFormatter(value.flatNumber) }}</span>
      </v-list-item>

      <v-list-item dense class="px-0 my-n2">
        <span class="font-weight-medium text-no-wrap me-2">{{ $t('city') }}:</span>
        <span class="text--secondary">{{ emptyValueFormatter(value.city) }}</span>
      </v-list-item>

      <v-list-item dense class="px-0 my-n2">
        <span class="font-weight-medium text-no-wrap me-2">{{ $t('zipCode') }}:</span>
        <span class="text--secondary">{{ emptyValueFormatter(value.zipCode) }}</span>
      </v-list-item>

      <v-list-item dense class="px-0 my-n2">
        <span class="font-weight-medium text-no-wrap me-2">{{ $t('state') }}:</span>
        <span class="text--secondary">{{ emptyValueFormatter(value.state) }}</span>
      </v-list-item>

      <v-list-item dense class="px-0 my-n2">
        <span class="font-weight-medium text-no-wrap me-2">{{ $t('country') }}:</span>
        <span class="text--secondary">{{ emptyValueFormatter(value.country) }}</span>
      </v-list-item>
    </template>

    <template v-else>
      <v-text-field
        v-model="value.street"
        outlined
        dense
        hide-details="auto"
        :label="$t('street')"
        :placeholder="$t('street')"
        maxlength="100"
        class="mb-3"
      />

      <v-row no-gutters class="mb-3">
        <v-col cols="12" sm="6" :class="[$vuetify.breakpoint.smAndUp ? 'pr-sm-2' : '']">
          <v-text-field
            v-model="value.houseNumber"
            outlined
            dense
            hide-details="auto"
            :label="$t('houseNumber')"
            :placeholder="$t('houseNumber')"
            maxlength="20"
          />
        </v-col>
        <v-col cols="12" sm="6" :class="[$vuetify.breakpoint.smAndUp ? 'pl-sm-2' : 'mt-3 mt-sm-0']">
          <v-text-field
            v-model="value.flatNumber"
            outlined
            dense
            hide-details="auto"
            :label="$t('flatNumber')"
            :placeholder="$t('flatNumber')"
            maxlength="20"
          />
        </v-col>
      </v-row>

      <v-row no-gutters class="mb-3">
        <v-col cols="12" sm="8" :class="[$vuetify.breakpoint.smAndUp ? 'pr-sm-2' : '']">
          <v-text-field
            v-model="value.city"
            outlined
            dense
            hide-details="auto"
            :label="$t('city')"
            :placeholder="$t('city')"
            maxlength="50"
          />
        </v-col>
        <v-col cols="12" sm="4" :class="[$vuetify.breakpoint.smAndUp ? 'pl-sm-2' : 'mt-3 mt-sm-0']">
          <v-text-field
            v-model="value.zipCode"
            outlined
            dense
            hide-details="auto"
            :label="$t('zipCode')"
            :placeholder="$t('zipCode')"
            maxlength="10"
          />
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12" sm="6" :class="[$vuetify.breakpoint.smAndUp ? 'pr-sm-2' : '']">
          <v-text-field
            v-model="value.state"
            outlined
            dense
            hide-details="auto"
            :label="$t('state')"
            :placeholder="$t('state')"
            maxlength="50"
          />
        </v-col>
        <v-col cols="12" sm="6" :class="[$vuetify.breakpoint.smAndUp ? 'pl-sm-2' : 'mt-3 mt-sm-0']">
          <v-text-field
            v-model="value.country"
            outlined
            dense
            hide-details="auto"
            :label="$t('country')"
            :placeholder="$t('country')"
            maxlength="50"
          />
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import { emptyValueFormatter } from '@core/utils/filter'

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      emptyValueFormatter,
    }
  },
}
</script>
